import { Box, Typography } from '@mui/material';
import { CheckRounded } from '@mui/icons-material';

import { DAY_OF_WEEK } from '../../../constants';
import { IMedicationConsistency } from '../../../constants/types';

const boxStyle = {
  width: 36,
  height: 36,
  ml: 'auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
};

const checkedBoxStyle = {
  ...boxStyle,
  bgcolor: 'secondary.main',
  color: 'common.white',
};

const unCheckedBoxStyle = {
  ...boxStyle,
  bgcolor: '#FE4D0133',
  color: 'common.white',
};

const MedicationBox = ({
  medication,
}: {
  medication: IMedicationConsistency;
}) => {
  const { medication_name, weekly_data } = medication;

  return (
    <Box sx={{ gap: '1px', mb: '2px' }} className="d-flex flex-column">
      <Box
        sx={{ bgcolor: 'common.white', px: 3, py: 5.25 }}
        className="rounded-50"
      >
        <Typography
          variant="body1"
          sx={{ mx: '11px', fontWeight: 600, mb: '10px' }}
        >
          {medication_name}
        </Typography>
        <Box
          sx={{ gridTemplateColumns: 'repeat(7, 1fr)', gap: 2 }}
          className="d-grid"
        >
          {weekly_data.map((weekDay, index: number) => {
            const { day, is_completed, expected_count, actual_count } = weekDay;

            return (
              <Box
                key={index}
                sx={{ gap: 1 }}
                className="d-flex flex-column align-items-center"
              >
                <Typography
                  variant="body2"
                  data-testid={day}
                  sx={{ color: 'tertiary.main' }}
                >
                  {DAY_OF_WEEK[day]}
                </Typography>

                {expected_count > 0 && (
                  <Box
                    sx={is_completed ? checkedBoxStyle : unCheckedBoxStyle}
                    className="d-flex justify-content-center align-items-center"
                  >
                    {is_completed && (
                      <CheckRounded sx={{ width: 20, height: 20 }} />
                    )}
                  </Box>
                )}

                {expected_count > 1 && (
                  <Typography variant="body2">
                    {actual_count}/{expected_count}
                  </Typography>
                )}
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default MedicationBox;
